import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class TextDecoration extends BaseOption {
  static userInterfaceComponent = {
    label: "Underline",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          label: "Yes",
          value: "underline",
          tooltip: "",
        },
        {
          label: "No",
          value: "none",
          tooltip: "",
        },
      ],
    },
  };

  static defaultValue = "none";
}
